import { jsxs as l, jsx as o } from "react/jsx-runtime";
import a from "react";
import n, { css as m } from "styled-components";
import { a as v, b as w, _ as b } from "../chunks/vendor_rango__tokens.38ee67b0.js";
import { R as C } from "../chunks/index.cff5baaf.js";
import { R as x } from "../chunks/Description.be3b00d1.js";
const y = n.div.withConfig({
  displayName: "Host",
  componentId: "sc-52bwpr-0"
})(["display:inline-block;position:relative;&::after{border-radius:var(--border-radius-sm);content:'';position:absolute;top:var(--spacing-half);left:calc(-1 * var(--spacing-1x));right:calc(-1 * var(--spacing-1x));bottom:var(--spacing-half);z-index:-1;transition-property:background-color,opacity;transition-timing-function:var(--curve-productive-exit);transition-duration:var(--duration-fast-01);}&:hover{&::after{", " transition-timing-function:var(--curve-productive-entrance);}}", ""], v, ({
  $clicked: t
}) => !t && m(["&:focus-within{&:after{", " outline-offset:2px;}}"], w)), _ = n.div.withConfig({
  displayName: "Dropdown",
  componentId: "sc-52bwpr-1"
})(["display:flex;position:relative;border:none;border-radius:var(--border-radius-sm);background-color:transparent;margin:0;padding:0;height:var(--spacing-6x);"]), k = n.select.withConfig({
  displayName: "HiddenSelect",
  componentId: "sc-52bwpr-2"
})(["position:absolute;width:100%;height:100%;z-index:9;opacity:0;cursor:pointer;"]), R = n.div.withConfig({
  displayName: "Content",
  componentId: "sc-52bwpr-3"
})(["display:flex;gap:var(--spacing-1x);flex-direction:row;align-items:center;position:relative;"]), D = n.span.withConfig({
  displayName: "Label",
  componentId: "sc-52bwpr-4"
})(["", " color:var(--text-label-color);"], b), I = a.forwardRef(({
  label: t = "",
  description: p = "",
  children: f,
  ...e
}, g) => {
  const [r, i] = a.useState(!1), [u, s] = a.useState(!1), [c, h] = a.useState(e.value || "");
  return /* @__PURE__ */ l(y, { $clicked: u, onClick: () => {
    s(!0), i(!r);
  }, "data-testid": "rango-dropdown", children: [
    /* @__PURE__ */ o(k, { ref: g, value: c, onBlur: () => {
      s(!1), i(!1);
    }, onChange: (d) => {
      h(d.target.value), i(!1), e.onChange && e.onChange(d);
    }, "data-rango-component": "rango-dropdown", "data-is-rango": !0, ...e, children: f }),
    /* @__PURE__ */ o(_, { children: /* @__PURE__ */ l(R, { children: [
      /* @__PURE__ */ o(x, { children: p }),
      /* @__PURE__ */ o(D, { children: c || t }),
      /* @__PURE__ */ o(C, { icon: r ? "DropdownCloseLine" : "DropdownOpenLine" })
    ] }) })
  ] });
});
I.displayName = "RangoDropdown";
export {
  I as RangoDropdown
};
